import help from './help.vue';
import ContactUs from './contactUs.vue';

const buddyRoutes = [
  {
    path: '/Help',
    component: help,
    meta: {
      title: 'Help',
    },
  },
  {
    path: '/Contact',
    component: ContactUs,
    meta: {
      title: 'Contact Us',
    },
  },
  {
    path: '/Help/:clubName/:clubId',
    component: help,
    meta: {
      title: 'Help',
      overrideStyle: true,
    },
  },
];

export default buddyRoutes;
